import React, { Component } from 'react';
import { Redirect, Route } from 'react-router-dom';

export class LoginAuthorSpotlight extends Component {
    constructor(props) {
        super(props);
        this.state = {
            redirectToSearch: false,
            authorName: ''
        }
    }

    decodeHtml(html) {
        var txt = document.createElement("textarea");
        txt.innerHTML = html;
        return txt.value;
    }

    redirectSearch(author) {
        this.setState({ authorName: author });
        this.setState({ redirectToSearch: true });
    }

    updateForAuthor = (e) => {
        this.state.searchAuthor = e;
        //window['SearchAuthor'] = e;
        this.setState({ redirectToSearch: true });
        //this.props.HomeCallbackAuthor(e);
    }

    renderAuth1 = () => {
        return this.props.AuthorList.map((item, key) => {
            return (key === 0 ?
                <div className="author-col-1 SetAuhtormargin">
                    <a href={item.externalUrl} target="_blank"> <img src={"/../../images/authorSpotlight/" + item.authorImage} alt={"Profile picture of " + this.decodeHtml(item.author.firstName) + this.decodeHtml(item.author.surname)} /></a>
                    <div>
                        <h1 className="BookHeading"><a href={item.externalUrl} target="_blank">
                            {this.decodeHtml(item.author.firstName)} {this.decodeHtml(item.author.surname)}</a></h1>
                        <p className="BookBody" style={{ marginTop: '-5px', marginBottom: '0px' }}>{item.description}…</p>

                    </div>
                </div> : null
            )
        }
        );
    }

    renderAuth2 = () => {
        return this.props.AuthorList.map((item, key) => {
            return (key === 1 ?
                < div >
                    <a href={item.externalUrl} target="_blank"><img className="Authorspotimg" src={"/../../images/authorSpotlight/" + item.authorImage} alt={"Profile picture of " + this.decodeHtml(item.author.firstName) + this.decodeHtml(item.author.surname)} /></a>
                    <span style={{ paddingLeft: '5%', width: '100%' }}>
                        <h3 className="BookHeading">
                            <a href={item.externalUrl} target="_blank">
                                {this.decodeHtml(item.author.firstName)} {this.decodeHtml(item.author.surname)}
                            </a>
                        </h3>
                        <p className="BookBody" style={{ marginTop: '-5px', marginBottom: '0px' }}>{item.description}… </p>


                    </span>
                </div >
                : null
            );
        })
    }

    renderAuth3 = () => {
        return this.props.AuthorList.map((item, key) => {
            return (key === 2 ?
                <div style={{ marginTop: '14px' }}><a href={item.externalUrl} target="_blank"> <img className="Authorspotimg" src={"/../../images/authorSpotlight/" + item.authorImage} alt={"Profile picture of " + this.decodeHtml(item.author.firstName) + this.decodeHtml(item.author.surname)} /></a>
                    <span style={{ paddingLeft: '5%', width: '100%' }}>
                        <h3 className="BookHeading">
                            <a href={item.externalUrl} target="_blank">
                                {this.decodeHtml(item.author.firstName)} {this.decodeHtml(item.author.surname)}</a>
                        </h3>
                        <p className="BookBody" style={{ marginTop: '-5px', marginBottom: '0px' }}>{item.description}… </p>

                    </span>
                </div>
                : null
            );
        })
    }

    render() {

        if (this.state.redirectToSearch) {

            this.setState({ redirectToSearch: false });
            return <Redirect to={"/SearchContent/query=?authorString=" + this.state.searchAuthor} />;
        }
        return (
            <div className="row LawHeader">
                <div id="author-spotlight" className="col-sm-6 setAuthorMaxwidth">
                        {this.renderAuth1()}
                </div>
                <div className="author-col-2 col-sm-6 setAuthorMaxwidth-2">
                    <ul>
                        {this.renderAuth2()}                        
                        {this.renderAuth3()}
                    </ul>
                </div>
            </div>
        )
    }
}

export default LoginAuthorSpotlight;


// WEBPACK FOOTER //
// ./src/components/LoginHome/LoginAuthorSpotlight.jsx